import Col from './col';
import useInternalBreakpoint from './hooks/useBreakpoint';
import Row from './row';
// Do not export params
function useBreakpoint() {
    return useInternalBreakpoint();
}
export { Row, Col };
export default { useBreakpoint };
